import type { Cadence } from './reportEnums.constants';
import { parseMeasurementPeriodEndYearMo } from './reportMeasurementPeriod.util';
import { reportingPeriodToYearMo } from './reportYearMo.util';

/**
 * Resolves the warehouse `YYYYMM` anchor for monthly/quarterly BigQuery sections.
 * @param cadence - Report cadence.
 * @param reportingPeriod - Stored reporting period label.
 * @param measurementPeriod - Optional JOC measurement period on the report.
 * @returns Six-digit year-month or null when not resolvable.
 */
export const resolveReportWarehouseYearMo = (
  cadence: Cadence,
  reportingPeriod: string,
  measurementPeriod?: string | null,
): string | null => {
  if (cadence === 'adhoc') {
    const source = measurementPeriod?.trim() || reportingPeriod.trim();
    return parseMeasurementPeriodEndYearMo(source);
  }
  return reportingPeriodToYearMo(reportingPeriod, cadence);
};

/**
 * Picks a warehouse measurement period whose end month matches `yearMo`.
 * @param yearMo - Anchor `YYYYMM`.
 * @param options - Distinct measurement period values for the customer.
 * @returns Matching period value or null.
 */
export const findMeasurementPeriodForYearMo = (
  yearMo: string,
  options: string[],
): string | null => {
  for (const option of options) {
    if (parseMeasurementPeriodEndYearMo(option) === yearMo) {
      return option;
    }
  }
  return null;
};
